// Utility for detecting app updates and notifying users
import { APP_VERSION } from './version';

export class UpdateDetector {
  private static instance: UpdateDetector;
  private currentVersion: string;
  private checkInterval: number = 5 * 60 * 1000; // 5 minutes
  private intervalId: NodeJS.Timeout | null = null;

  private constructor() {
    this.currentVersion = this.getAppVersion();
  }

  static getInstance(): UpdateDetector {
    if (!UpdateDetector.instance) {
      UpdateDetector.instance = new UpdateDetector();
    }
    return UpdateDetector.instance;
  }

  private getAppVersion(): string {
    // Use the centralized version from package.json
    return APP_VERSION;
  }

  private async checkForUpdates(): Promise<boolean> {
    try {
      // Fetch a version file or check against a known endpoint
      const response = await fetch('/version.json', { 
        cache: 'no-cache',
        headers: { 'Cache-Control': 'no-cache' }
      });
      
      if (response.ok) {
        const data = await response.json();
        const serverVersion = data.version || data.buildTime;
        
        if (serverVersion !== this.currentVersion) {
          console.log('[UpdateDetector] New version detected:', serverVersion, 'Current:', this.currentVersion);
          return true;
        }
      }
    } catch (error) {
      console.warn('[UpdateDetector] Failed to check for updates:', error);
    }
    
    return false;
  }

  public startMonitoring(): void {
    if (this.intervalId) {
      this.stopMonitoring();
    }

    this.intervalId = setInterval(async () => {
      const hasUpdate = await this.checkForUpdates();
      if (hasUpdate) {
        this.notifyUser();
      }
    }, this.checkInterval);
  }

  public stopMonitoring(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private notifyUser(): void {
    // Create a notification banner
    const banner = document.createElement('div');
    banner.id = 'update-notification';
    banner.innerHTML = `
      <div style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: #2563eb;
        color: white;
        padding: 12px;
        text-align: center;
        z-index: 9999;
        font-family: system-ui, -apple-system, sans-serif;
        font-size: 14px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      ">
        <span>🔄 Una nuova versione è disponibile</span>
        <button onclick="window.location.reload()" style="
          margin-left: 12px;
          background: white;
          color: #2563eb;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
          font-weight: 500;
        ">Aggiorna ora</button>
        <button onclick="this.parentElement.remove()" style="
          margin-left: 8px;
          background: transparent;
          color: white;
          border: 1px solid white;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
        ">✕</button>
      </div>
    `;
    
    document.body.appendChild(banner);
  }

  public forceCheck(): Promise<boolean> {
    return this.checkForUpdates();
  }
} 